import { NgModule,LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { EscrituraIndexComponent } from './EscrituraIndex.component';
import { EscrituraEditComponent } from './EscrituraEdit.component';
import { EscrituraIdEditComponent } from './EscrituraIdEdit.component';
import { asignarPDFEscrituraComponent } from './asignarPDFEscritura.component';
import { asignarPDFCostosComponent } from './asignarPDFCostos.component';
import { SeguimientoEstadoEscriturasComponent } from './SeguimientoEstadoEscrituras.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';
import { MatDialogModule } from '@angular/material';
import { SeguimientoEstadoEscrituraNewComponent } from './SeguimientoEstadoEscrituraNew.component';






const routes = [
    {
        path     : 'Escritura',
        component: EscrituraIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Escritura',
          nombreFormulario : 'Escrituras'
        } 
    },
    {
        path     : 'Escritura/i/:cnumcont/:cprefijo/:edi',
        component: EscrituraIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Escritura',
          nombreFormulario : 'Escrituras'
        } 
    },
    {
        path     : 'Escritura/:cnumcont/:ccodcon',
        component: EscrituraIndexComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Escritura',
          nombreFormulario : 'Escritura Filtro Contrato - Prefijo'
        } 
    },
    {
        path     : 'Escritura/:editar/:cnumcont/:vidEscritura/:cprefijo',
        component: EscrituraEditComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Escritura',
          nombreFormulario : 'Editar Escritura'
        } 
    },
    {
        path     : 'Escritura/:editar/:cnumcont/:cprefijo',
        component: EscrituraEditComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Escritura',
          nombreFormulario : 'Crear Escritura'
        } 
    },
    {
      path     : 'Escritura/:editar/:cnumcont/:vidEscritura/:cprefijo/:hg/:hg/:hg',
      component: EscrituraIdEditComponent,
      canActivate: [RoleGuard], 
      data: { 
        formulario: 'Escritura',
        nombreFormulario : 'Editar ID Escritura'
      } 
    },
    {
      path     : 'Escritura/:editar/:cnumcont/:vidEscritura/:cprefijo/:ndocumento',
      component: asignarPDFEscrituraComponent,
      canActivate: [RoleGuard], 
      data: { 
        formulario: 'Escritura',
        nombreFormulario : 'AsignarPDFEscritura'
      } 
    },
    {
        path     : 'Escritura/:editar/:cnumcont/:vidEscritura/:cprefijo/:ndocumento/:ndocumentocostos',
        component: asignarPDFCostosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Escritura',
          nombreFormulario : 'AsignarPDFCostos'
        }
    },
    {
    path     : 'Escritura/:cnumcont/:videscritura/:cprefijo/:seguimientoEstado/:seguimientoEstado2/:seguimientoEstado3/:seguimientoEstado4/:seguimientoEstado5',
    component: SeguimientoEstadoEscriturasComponent,
    canActivate: [RoleGuard], 
    data: { 
      formulario: 'Escritura',
      nombreFormulario : 'Seguimiento Estado Escrituras'
          },
    },
    {
      path     : 'Escritura/:cnumcont/:videscritura/:cprefijo/:seguimientoEstado/:seguimientoEstado2/:seguimientoEstado3/:seguimientoEstado4/:seguimientoEstado5/:seguimientoEstado6/:seguimientoEstado7',
      component: SeguimientoEstadoEscrituraNewComponent,
      canActivate: [RoleGuard], 
      data: { 
        formulario: 'Escritura',
        nombreFormulario : 'Seguimiento Estado Escrituras New'
      } 
    }
];

@NgModule({
    declarations: [
        EscrituraIndexComponent,
        EscrituraEditComponent,
        SeguimientoEstadoEscriturasComponent,
        SeguimientoEstadoEscrituraNewComponent,
        EscrituraIdEditComponent
    ],
    imports     : [
        SharedModule,
        MatDialogModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        EscrituraIndexComponent,
        EscrituraEditComponent,
        SeguimientoEstadoEscriturasComponent,
        SeguimientoEstadoEscrituraNewComponent,
        EscrituraIdEditComponent
    ], 
    providers: [{
      provide: LOCALE_ID,
      useValue: 'es-CO' // 'de-DE' for Germany, 'fr-FR' for France ...
    }]
})

export class EscrituraModule
{
}




// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CrearEscritura/Escritura.module.ts